export default "__VITE_ASSET__B8fZh1Mh__"